import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Fieldset, Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PrivateInformationFormSchemaType } from '../../hooks';
import { BirthdateInputField } from '../BirthdateInputField';

const TRANS_PATH =
  'PRIVATE_INFORMATION.EDIT_PRIVATE_INFORMATION_FORM.PERSONAL_INFORMATION_FIELDS';

export const PersonalInformationFields: React.FC = () => {
  const { t } = useTranslation('personDetailsGeneral');

  return (
    <Fieldset legend={t(`${TRANS_PATH}.PERSONAL_INFORMATION_LABEL`)}>
      <Grid>
        <Grid.Col span={4}>
          <TextField<PrivateInformationFormSchemaType>
            fieldName="firstname"
            label={t(`${TRANS_PATH}.FIRSTNAME_LABEL`)}
            required
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <TextField<PrivateInformationFormSchemaType>
            fieldName="lastname"
            label={t(`${TRANS_PATH}.LASTNAME_LABEL`)}
            required
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <TextField<PrivateInformationFormSchemaType>
            fieldName="nickname"
            label={t(`${TRANS_PATH}.NICKNAME_LABEL`)}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <BirthdateInputField label={t(`${TRANS_PATH}.BIRTHDAY_LABEL`)} />
        </Grid.Col>
      </Grid>
    </Fieldset>
  );
};
